import React from 'react';
import { useRouteMatch } from 'react-router';
import { Box, ElectronicIcon,Inscription, PaperIcon, Preloader } from '@common-fe/common-fe';

import { useGetEmployeeViewQuery } from './queries/useGetEmployeeView.query';

export const ElectronicStatementMessage = () => {
  const { params: { id: employeeId } } = useRouteMatch<{ id: string }>();
  const { employeeViewData, isLoading } = useGetEmployeeViewQuery(employeeId);

  return (
    <Box
      data-testId="ElectronicStatementMessage"
      direction="row"
      align="center"
    >
      {isLoading ? <Preloader size={10} thinSize={2} testId="ElectronicStatementMessage_loading" /> : (
        <>
          <Inscription
            color="success"
            size="medium"
            margin={{ right: 'spacing4' }}
          >
            {employeeViewData?.isElectronicStatementOnly
              ? 'Opted-in to electronic only'
              : 'Opted-in to paper and electronic'}
          </Inscription>
          {employeeViewData?.isElectronicStatementOnly ? <ElectronicIcon color="success" size="14px" /> : <PaperIcon color="success" size="14px" />}
        </>
      )}
    </Box>
  );
};
